import { t } from "i18next";
import { getAPIClient, DocketAPIError } from "../apiClient";
import { ImmunizationSearch } from "../models/Interfaces";
import { useState } from "react";
import { useAtom } from "jotai";
import { izSearchAPIResultAtom, selectedSearchAtom } from "../jotai/atoms";
import { ImageIcon } from "./ImageIcon";
import { twMerge } from "tailwind-merge";
import { ErrorModal } from "./modals/ErrorModal";
import React from "react";

type ErrorModalParams = {
  title: string;
  body: string;
  show: boolean;
};

export const DeleteSearchButton = ({ onDelete }: { onDelete?: () => void }) => {
  const [_izSearchAPIResult, setIzSearchAPIResult] = useAtom(izSearchAPIResultAtom);
  const [existingSearch, setExistingSearch] = useAtom(selectedSearchAtom);
  const [deleting, setDeleting] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState<ErrorModalParams>({
    title: "",
    body: "",
    show: false,
  });
  const runDeleteSearch = async () => {
    if (!existingSearch) {
      return null;
    }
    try {
      setDeleting(true);
      await getAPIClient().deleteIzSearch(existingSearch.uid, existingSearch.izProviderKey);
      const updatedSearches = await getAPIClient().getIzSearches(false);
      await setIzSearchAPIResult(updatedSearches.data);
      setExistingSearch(null);
      onDelete?.();
    } catch (e: unknown) {
      if (e instanceof DocketAPIError) {
        setShowErrorModal({
          title: t("immunizations.search_check_search_not_deleted"),
          body: e.message,
          show: true,
        });
      }
    } finally {
      setDeleting(false);
    }
  };
  return (
    <>
      {showErrorModal.show && (
        <>
          hi
          <ErrorModal
            title={showErrorModal.title}
            onCloseModal={() =>
              setShowErrorModal((cur: ErrorModalParams): ErrorModalParams => {
                return { title: cur.title, body: cur.body, show: false };
              })
            }
          >
            <p>{showErrorModal.body}</p>
          </ErrorModal>
        </>
      )}
      {existingSearch && (
        <button
          disabled={deleting}
          onClick={() => runDeleteSearch()}
          className="btn btn-primary btn-ghost text-primary-content "
        >
          {deleting ? (
            <span className="loading loading-spinner loading-lg"></span>
          ) : (
            <ImageIcon src="/assets/images/Icon_Trash_White.png" />
          )}
        </button>
      )}
    </>
  );
};
